import logoMark from "@/assets/logo-mark.png";

const LETTERS = [
  ["B", "#E6337F"], ["o", "#F5911E"], ["o", "#F5911E"], ["k", "#6DBE45"],
  ["M", "#22B7C6"], ["y", "#7A3FA0"],
  ["E", "#E6337F"], ["v", "#F5911E"], ["e", "#7A3FA0"], ["n", "#F5911E"], ["t", "#2E9BD6"],
];

export function BrandLockup({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-lockup">
      <img src={logoMark} alt="Book My Event" className="h-12 w-auto object-contain" />
      <span className="font-extrabold text-2xl tracking-tight" style={{ fontFamily: "'Baloo 2', sans-serif" }}>
        {LETTERS.map(([ch, c], i) => <span key={i} style={{ color: c }}>{ch}</span>)}
        <span style={{ color: "#2E9BD6", fontSize: "0.65em" }}>.xyz</span>
      </span>
    </div>
  );
}
